import React from "react";
import Header from "../components/header/header";
import Youtubelive from "../components/youtube_live/youtube_live";
import Dailydarshan from "../components/dailydarshan/dailydarshan";
import Books from "../components/books/books";
import Resources from "../components/resources/resources";
import Mobileapp from "../components/mobileapp/mobileapp";
import Upcomingevent from "../components/upcomingevent/upcomingevent";
import Footer from "../components/footer/footer";
import Latestevent from "../components/latestevent/latestevent";
import Socialmedia from "../components/socialmedia/socialmedia";
import Form from "../components/form/form";
import Sidesocialmedia from "../components/sidesocialmedia/sidesocialmedia";

const Home = () => {
  return (
    <div>
      <Header />
      <Sidesocialmedia />
      <Youtubelive />
      <Dailydarshan />
      <Upcomingevent />
      <Books />
      <Resources />
      <Latestevent />
      <Mobileapp />
      <Form />
      <Socialmedia />
      <Footer />
    </div>
  );
};

export default Home;
